module.exports = __webpack_public_path__ + "static/img/rejectIcon.798c44b2.png";